/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Image
import bgImage from "assets/images/send.jpg";

function ContactUs() {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <MKBox sx={{ backgroundColor: "rgba(17, 88, 194, 0.54)" }}>
      <MKBox position="fixed" top="0.5rem" width="100%" zIndex={10}>
        <DefaultNavbar
          routes={routes}
          action={{
            type: "internal",
            route: "/pages/landing-pages/contact-us",
            label: "contáctanos",
            color: "info",
          }}
        />
      </MKBox>
      <MKBox width="calc(100% - 48px)" mx="auto" sx={{ pt: 8, pb: 3 }}>
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12} lg={5}>
            <MKBox
              display={{ xs: "none", lg: "flex" }}
              width="100%"
              height="100%"
              minHeight="calc(100vh - 2rem)"
              borderRadius="lg"
              ml={0}
              mt={0}
              sx={{
                backgroundImage: isDarkMode
                  ? `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${bgImage})`
                  : `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={10} md={7} lg={5} xl={4}>
            <MKBox
              bgColor={isDarkMode ? "dark" : "white"}
              borderRadius="xl"
              shadow="lg"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              mt={8}
              mb={8}
            >
              <MKBox
                variant="gradient"
                bgColor="info"
                coloredShadow="info"
                borderRadius="lg"
                p={2}
                mx={2}
                mt={-3}
              >
                <MKTypography variant="h3" color="white">
                  Contáctanos
                </MKTypography>
              </MKBox>
              <MKBox p={3}>
                <MKTypography variant="body2" color={isDarkMode ? "white" : "text"} mb={3}>
                  Si tienes dudas sobre nuestros productos o deseas una cotización, escríbenos a{" "}
                  <strong>contacto@impresia.com.mx</strong>, llámanos al{" "}
                  <strong>55 6678 9291</strong> o visítanos en{" "}
                  <strong>
                    Privada de las Flores 350, Club de golf. Av Mexico, Tlalpan, CDMX, C.P. 14629
                  </strong>
                </MKTypography>
                <MKBox width="100%" component="form" method="post" autoComplete="off">
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <MKInput
                        variant="standard"
                        label="Nombre"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <MKInput
                        type="email"
                        variant="standard"
                        label="Email"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MKInput
                        variant="standard"
                        label="En que te podemos ayudar?"
                        placeholder="Describe tu problema en al menos 250 caracteres"
                        InputLabelProps={{ shrink: true }}
                        multiline
                        fullWidth
                        rows={6}
                      />
                    </Grid>
                  </Grid>
                  <Grid container item justifyContent="center" xs={12} mt={5} mb={2}>
                    <MKButton type="submit" variant="gradient" color="info">
                      Enviar
                    </MKButton>
                  </Grid>
                </MKBox>
              </MKBox>
            </MKBox>
          </Grid>
        </Grid>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </MKBox>
  );
}

export default ContactUs;
